<template>
  <div class="content-wrapper">
    <div class="domains-list-content-root-wrapper">
      <ErrorMessage
        v-if="isError"
        :header="$t('common.error.api')"
        :content="$t('common.error.api_content')"
      />
      <TableListLoader
        v-else-if="isLoading"
        :listStructure="domainRowStructure"
      />
      <ListLegend
        v-else
        :legends="legends"
        :legendsFlexStructure="legendsFlexStructure"
      />
      <DomainsListTable :selectedZones="selectedZones" :variant="variant" :showObsolete="showObsolete" />
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import ErrorMessage from '@/components/common/ErrorMessage/ErrorMessage.vue';
import ListLegend from '@/components/common/ListLegend/ListLegend.vue';
import TableListLoader from '@/components/common/TableListLoader/TableListLoader.vue';
import DomainsListTable from '@/views/TollDomains/Domains/components/DomainsListTable/DomainsListTable.vue';
import { ITollDomainsState, store } from '@/store/modules/tollDomain/types';
import './styles/domains-list-content.scss';
import { Zone } from 'ctp-geometry';

@Component({
  components: {
    ErrorMessage,
    ListLegend,
    TableListLoader,
    DomainsListTable
  }
})
export default class DomainsListContent extends Vue {
  @Prop()
  private selectedZones: Zone[];

  @Prop()
  private variant: number;

  @Prop()
  private showObsolete: boolean;

  @store.Getter
  private getTollDomainsState!: ITollDomainsState;

  private domainsListLegends() {
    let legends = [
      {
        label: 'map.tolldomains.legends.validFrom'
      },
      {
        label: 'map.tolldomains.legends.to'
      },
      {
        label: 'map.tolldomains.legends.status'
      }
    ];

    if (!this.selectedZones) {
      legends = [
        {
          label: 'map.tolldomains.legends.configuration_variant'
        },
        {
          label: 'map.tolldomains.legends.toll_domain'
        }]
        .concat(legends)
        .concat(
          {
            label: 'map.tolldomains.legends.modified_by'
          }
        );
    } else {
      legends = [
        {
          label: 'map.tolldomains.legends.toll_domain'
        }]
        .concat(legends);
    }
    return legends;
  }

  private legends = this.domainsListLegends();

  private domainRowStructure = {
    data: 4,
    withCheckbox: false,
    withExpansion: true
  };

  private legendsFlexStructure = this.domainsListLegends().map(() => '1 1 0');

  private get isLoading(): boolean {
    return this.getTollDomainsState.loading.domains;
  }

  private get isError() {
    return this.getTollDomainsState.error.domains;
  }
}
</script>
